import { memo } from "react"

const FacilityAddress = memo(({city,address,})=>{
    return (
        <address>
            {city ? city :null}
            {address ? ', '+ address :null}
      </address>
    )
})
export default FacilityAddress